import { normalizeLocale } from "./routeLocale";

/**
 * Per-locale feature scope — Sprint 2 international shell.
 * `"*"` = full product (Hebrew only during transition).
 */
export const LANGUAGE_FEATURES = Object.freeze({
  he: ["*"],

  en: ["auth", "common", "hotel_search"],

  el: ["auth", "common", "hotel_search"],

  default: ["auth", "common", "hotel_search"],
});

export function getLanguageFeatures(locale) {
  const lng = normalizeLocale(locale);
  if (lng === "he") return LANGUAGE_FEATURES.he;
  if (lng === "en") return LANGUAGE_FEATURES.en;
  if (lng === "el") return LANGUAGE_FEATURES.el;
  return LANGUAGE_FEATURES.default;
}

export function isFullLocale(locale) {
  const features = getLanguageFeatures(locale);
  return features.includes("*");
}

export function isFeatureAllowedForLocale(locale, feature) {
  if (!feature) return true;
  const features = getLanguageFeatures(locale);
  if (features.includes("*")) return true;
  return features.includes(feature);
}
